import React from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';

const MarkdownCore = ({
    children,
}: {
    children: string;
    isFinished?: boolean;
    messageId?: string;
    feature?: {
        enableLinkCard?: boolean;
        enableHtml?: boolean;
    };
}) => {
    const md = children;

    return (
        <ReactMarkdown
            remarkPlugins={[gfm]}>
            {md}
        </ReactMarkdown>
    );
};
export default MarkdownCore;
